import React from 'react'
import Hero from '../../components/Hero/Hero';
import heroImage from '../../assets/images/Insurance/Hero.svg';
import Industries from '../../components/Industries/Industries';
import image from '../../assets/images/Insurance/image1.jpg'
const Insurance = () => {
  return (
    <>
     {/* start hero section  */}
     <Hero
        image={heroImage}
        image_name="Insurance"
        page_name="Insurance"
        heading="Insurance Technology and Guidewire Solutions"
      />
      {/* end hero section  */}

      <div className="container py-lg-5 py-md-4 py-3">
        <Industries
            heading1="SERVICES For "
            heading2="Insurance"
            content="we deliver end-to-end insurance technology solutions that empower insurers to streamline policy administration, claims management, and billing operations while ensuring regulatory compliance and operational efficiency. Leveraging our expertise in Guidewire modules such as ClaimCenter, PolicyCenter, and BillingCenter, we provide skilled developers, senior developers, and QA engineers who seamlessly integrate with your teams to accelerate delivery and enhance quality. Our approach combines deep insurance domain knowledge with agile delivery practices, enabling organizations to gain better control over their processes, make data-driven decisions, and respond quickly to market changes. By focusing on reliable resource augmentation and technology-driven solutions, we help insurers reduce operational risk, optimize workflows, and achieve measurable business outcomes. Whether supporting core Guidewire implementations or extending IT capabilities, TechTorch Solutions stands as a trusted partner in modernizing insurance operations and driving digital transformation across the enterprise."
            image={image}
            image_name="INSUARNCE SERVICES"
        />
      </div>
   </>
  )
}

export default Insurance
